import React, { useEffect, useContext } from 'react'
import GeneralContext from '../../context/GeneralContext'
import styles from './PesoTalla.module.css'

//Utiles
import * as Constantes from '../../utils/constantes'
import Subtitle from '../Subtitle'

const PesoTalla = ({ peso, estatura, state, setState }) => {

    const { state: generalState } = useContext(GeneralContext)
    let user = generalState.users.filter(user => user.isAuthenticated)[0]
    let prospecto = user.listaProspectos.filter(prospecto => prospecto.isSelected)[0]
    let cotizacion = prospecto.cotizaciones.filter(cotizacion => cotizacion.isSelected || cotizacion.completado)[0]

    useEffect(() => {
       
    }, [])

    //Modo lectura
    let Deshabilitar = (complete) => {
        complete = cotizacion.edicionInhabilitada
        if (complete === true) {
            return true
        } else {
            return false
        }
    }

    const handleChangeNumber = (e, campo) => {
        const value = e.target.value.replace(/\D/g, '');
        
        setState((state) => {
            return {
                ...state,
                [campo]: value,
                campoValidado: {
                    ...state.campoValidado,
                    [campo]: true
                }
            }
        })   
    }

    const preventDotInput = (e) => {
        if (e.key === '.') {
            e.preventDefault();
        }
    }

    const estaturaAux = estatura?.replace('.', '');

    return (
        <div className={styles['areadatosprospecto']}>
            <Subtitle
                sname='¿Cuál es su peso y talla?'
                smostrar='false'
            />
            <div>
                <div className={styles['contenedor2']}>
                   
                    <div className={styles['caja-1']}>
                        <label>Estatura (Máx 270cm)&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                        <input type='number'
                            placeholder='0'
                            className={!state.campoValidado.estatura ? styles['logerror'] : null}
                            value={estaturaAux || ''}
                            onChange={(e) => handleChangeNumber(e, 'estatura')}
                            onKeyDown={preventDotInput}
                            disabled={Deshabilitar() !== true ? false : true} />
                        {!state.campoValidado.estatura &&
                            <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_ALTURA}</span>
                        }
                    </div>
                    
                    <div className={styles['caja-2']}>
                        <label>Peso (Máx 300kg)&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                        <input type='number'
                            placeholder='0'
                            className={!state.campoValidado.peso ? styles['logerror'] : null}
                            value={peso || ''}
                            onChange={(e) => handleChangeNumber(e, 'peso')}
                            onKeyDown={preventDotInput}
                            disabled={Deshabilitar() !== true ? false : true}
                        />
                        {!state.campoValidado.peso &&
                            <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_PESO}</span>
                        }
                    </div>
                  
                </div>
              
            </div>
        </div>
    )
}

export default PesoTalla